import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import OmOs from "@/pages/OmOs";
import Cases from "@/pages/Cases";
import Faq from "@/pages/Faq";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import ForGaester from "@/pages/ForGaester";
import Firmaboliger from "@/pages/Firmaboliger";
import FirmaboligDetail from "@/pages/FirmaboligDetail";
import CookieConsent from "@/components/site/CookieConsent";
import { Toaster } from "sonner";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/om-os" element={<OmOs />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/privatlivspolitik" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/for-gaester" element={<ForGaester />} />
          <Route path="/firmaboliger" element={<Firmaboliger />} />
          <Route path="/firmaboliger/:slug" element={<FirmaboligDetail />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton theme="light" />
    </div>
  );
}

export default App;
